<template>
  <div class="col-md-12 invoice_list">
    <div
        class="main_filters"
        :class="(filters_state)? 'main_fiters_toggler--active' : 'main_fiters_toggler'"
        @click="toggleFiltersState"
    >
      <span
          class="mdi"
          :class="(filters_state)? 'mdi-filter-remove' : 'mdi-filter'"
          @click="toggleFiltersState"
      />
      <span class="main_fiters_toggler_text">
        {{ (filters_state)? translate('filter.hide') : translate('filter.show') }}
      </span>
    </div>

    <div class="header" :class="filters_state === true ? 'shown' : 'hidden'">
      <div class="wrap_select">
        <div class="form_select">
          <WrapDatePicker
              type="month"
              value_type="YYYY-MM"
              v-model="filter.date"
              :range="false"
              :placeholder="translate('invoice.reporting_period')"
              :clearable="true"
              :confirm="false"
              @input="change_input"
          />
        </div>

        <div class="form_select">
          <tree-select
              :options="status_list"
              :multiple="false"
              v-model="filter.validation_status"
              :placeholder="translate('invoice.validation_status')"
              :clearable="true"
              @input="change_input"
          />
        </div>
      </div>

      <div class="wrap_select">
        <div class="form_select">
          <tree-select
              :options="client_list"
              :multiple="true"
              v-model="filter.client_ids"
              :placeholder="translate('invoice.client_name')"
              :clearable="true"
              :clear-on-select="true"
              @input="change_input"
          />
        </div>

        <div class="form_select">
          <tree-select
              :options="type_list"
              :multiple="false"
              v-model="filter.type"
              :placeholder="translate('invoice.type')"
              :clearable="true"
              @input="change_input"
          />
        </div>
      </div>

      <div class="wrap_select">
        <div class="form_select">
          <WrapDatePicker
              type="date"
              :placeholder="translate('invoice.issue_period')"
              v-model="filter.date_create"
              :range="true"
              :confirm="true"
              :disabled_date="['- 12 month', 'now']"
              value_type="YYYY-MM-DD"
              @input="change_input"
          />
        </div>

        <div class="form_select">
          <fg-input
              v-model="filter.invoice_number"
              type="text"
              :placeholder="translate('invoice.invoice_number')"
              :clearable="true"
              @input="change_invoice_number"
          />
        </div>
      </div>

      <div class="wrap_select">
        <div class="form_select">
          <tree-select
              :options="option_list"
              :multiple="true"
              v-model="options"
              :placeholder="translate('invoice.options')"
              :clearable="true"
          />
        </div>
        <div class="form_select">
          <tree-select
              :options="payment_status_list"
              :multiple="false"
              v-model="filter.payment_status"
              :placeholder="translate('invoice.payment_status')"
              :clearable="true"
              @input="change_input"
          />
        </div>
      </div>

      <div class="wrap_select"></div>
    </div>

    <div class="response_table">
      <div class="summary card" v-if="summary.length > 0">
        <p v-for="(sum, key) in summary" :key="key">
          <span>{{ translate("invoice.summary." + sum.name) }}:</span>
          <span v-html="sum.value" />
        </p>
      </div>

      <table>
        <thead style="height: 50px; flex:0; display: inline-block">
          <tr>
            <th
                class="pointer text-left"
                @click="change_filter('client_name')"
                :class="{ selected: filter_type === 'client_name' }"
                scope="col"
            >
              {{ translate('invoice.client_name') }}
              <i
                  class="mdi mdi-arrow-down"
                  :class="{ reverse: filter_asc === 'desc' }"
              />
            </th>

            <th
                class="pointer text-left"
                @click="change_filter('invoice_name')"
                :class="{ selected: filter_type === 'invoice_name' }"
                scope="col"
            >
              {{ translate('invoice.invoice_name') }}
              <i
                  class="mdi mdi-arrow-down"
                  :class="{ reverse: filter_asc === 'desc' }"
              />
            </th>

            <th
                class="pointer w100"
                @click="change_filter('date')"
                :class="{ selected: filter_type === 'date' }"
                scope="col"
            >
              {{ translate('invoice.period') }}
              <i
                  class="mdi mdi-arrow-down"
                  :class="{ reverse: filter_asc === 'desc' }"
              />
            </th>

            <th
                class="pointer w100"
                @click="change_filter('invoice_number')"
                :class="{ selected: filter_type === 'invoice_number' }"
                scope="col"
            >
              {{ translate('invoice.invoice_number') }}
              <i
                  class="mdi mdi-arrow-down"
                  :class="{ reverse: filter_asc === 'desc' }"
              />
            </th>

            <th
                class="pointer w50"
                @click="change_filter('type_title')"
                :class="{ selected: filter_type === 'type_title' }"
                scope="col"
            >
              {{ translate('invoice.type') }}
              <i class="mdi mdi-arrow-down" :class="{ reverse: filter_asc === 'desc' }" />
            </th>

            <th
                class="pointer w100"
                @click="change_filter('device_count')"
                :class="{ selected: filter_type === 'device_count' }"
                scope="col"
            >
              {{ translate('invoice.device') }}
              <i
                  class="mdi mdi-arrow-down"
                  :class="{ reverse: filter_asc === 'desc' }"
              />
            </th>

            <th
                class="pointer sum w100"
                @click="change_filter('sum')"
                :class="{ selected: filter_type === 'sum' }"
                scope="col"
            >
              {{ translate('invoice.price_with_vat') }}
              <i
                  class="mdi mdi-arrow-down"
                  :class="{ reverse: filter_asc === 'desc' }"
              />
            </th>

            <th
                class="pointer"
                @click="change_filter('validation_status')"
                :class="{ selected: filter_type === 'validation_status' }"
                scope="col"
            >
              {{ translate('invoice.validation_status') }}
              <i
                  class="mdi mdi-arrow-down"
                  :class="{ reverse: filter_asc === 'desc' }"
              />
            </th>

            <th
                class="pointer"
                @click="change_filter('date_act')"
                :class="{ selected: filter_type === 'date_act' }"
                scope="col"
            >
              {{ translate('invoice.date_act') }}
              <i
                  class="mdi mdi-arrow-down"
                  :class="{ reverse: filter_asc === 'desc' }"
              />
            </th>

            <th
                class="pointer"
                @click="change_filter('date_create')"
                :class="{ selected: filter_type === 'date_create' }"
                scope="col"
            >
              {{ translate('invoice.issue_date') }}
              <i
                  class="mdi mdi-arrow-down"
                  :class="{ reverse: filter_asc === 'desc' }"
              />
            </th>

            <th
                class="pointer w50"
                @click="change_filter('client_edo_id')"
                :class="{ selected: filter_type === 'client_edo_id' }"
                scope="col"
            >
              {{ translate('invoice.edo') }}
              <i
                  class="mdi mdi-arrow-down"
                  :class="{ reverse: filter_asc === 'desc' }"
              />
            </th>

            <th
                class="pointer w50"
                @click="change_filter('is_correction')"
                :class="{ selected: filter_type === 'is_correction' }"
                scope="col"
            >
              {{ translate('invoice.is_correction') }}
              <i class="mdi mdi-arrow-down" :class="{ reverse: filter_asc === 'desc' }" />
            </th>

            <th
                class="pointer sum"
                @click="change_filter('payment_status')"
                :class="{ selected: filter_type === 'payment_status' }"
                v-if="$store.getters.getPermissions.permissionGod  === true"
                scope="col"
            >
              {{ translate('invoice.payment_status') }}
              <i
                  class="mdi mdi-arrow-down"
                  :class="{ reverse: filter_asc === 'desc' }"
              />
            </th>

            <th
                class="pointer sum"
                @click="change_filter('date_payment')"
                :class="{ selected: filter_type === 'date_payment' }"
                v-if="$store.getters.getPermissions.permissionGod  === true"
                scope="col"
            >
              {{ translate('invoice.date_payment') }}
              <i
                  class="mdi mdi-arrow-down"
                  :class="{ reverse: filter_asc === 'desc' }"
              />
            </th>
          </tr>
        </thead>
        <tbody>
          <InvoiceItem
              v-for="(invoice,key) in invoices"
              :key="key"
              :invoice="invoice"
          />
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import InvoiceItem from "./Item/Index.vue";
import WrapDatePicker from "components/UIComponents/WrapDatePicker/WrapDatePicker.vue";

export default {
  name: 'InvoiceList',
  components: {
    WrapDatePicker,
    InvoiceItem
  },
  data () {
    return {
      invoice_list: [],
      check_link: true,
      filter:{
        date: null,
        date_create: [],
        client_ids: [],
        invoice_number: "",
        validation_status: null,
        payment_status: null
      },
      filter_asc: "asc",
      filter_type: "",
      summary: {},
      filters_state: (this.localStorage.getItem('filters_state') !== null) ? (this.localStorage.getItem('filters_state') === 'true') : true,

      options: ["hide_with_null"]
    }
  },

  computed:{
    sended_filter() {
      let filter = {};
      Object.keys(this.filter).forEach((key) => {
        if (key === 'date_create'){
          if (this.filter[key].length > 0 && this.filter[key][0] !== null && this.filter[key][1]){
            filter["date_start"] = this.filter[key][0]
            filter["date_end"] = this.filter[key][1]
          }
        }else if (key === 'client_ids'){
          if (this.filter[key].length > 0){
            filter[key] = this.filter[key]
          }
        }else{
          if (this.filter[key] !== "" && this.filter[key] !== null && this.filter[key] !== undefined){
            filter[key] = this.filter[key]
          }
        }
      })
      return filter;
    },
    option_list(){
      return [
        {id: "hide_with_null", label: this.translate("invoice.hide_with_null")}
      ]
    },
    payment_status_list(){
      return this.$store.getters.getClientInvoicesInfo.payment_statuses.map((status) => {
        return {id: status.id, label: status.descr}
      })
    },

    type_list(){
      return this.$store.getters.getClientInvoicesInfo.types.map((status) => {
        return {id: status.id, label: status.descr}
      })
    },

    invoices(){
      let invoices = [...this.invoice_list];
      if (this.options.indexOf("hide_with_null") > -1){
        invoices = this.invoice_list.filter((invoice) => {
          return Number(invoice.sum) !== 0
        })
      }else{
        invoices = [...this.invoice_list];
      }

      return invoices.sort(this.compareNumbers);
    },
    client_list(){
      return this.$store.getters.getClientsList.map((client) => {
        return { id: client.id, label: client.name }
      })
    },
    status_list(){
      return this.$store.getters.getClientInvoicesInfo.validation_statuses.map((status) => {
        return { id: status.id, label: this.translate("invoice.validation_statuses." + status.title) }
      })
    },
  },

  watch:{
    filter:{
      deep: true,
      handler() {
        if (this.$route.name === 'invoice_list_section') {
          let string = '?'

          for (let key in this.filter) {
            switch (key) {
              case 'date':
              case 'validation_status':
              case 'invoice_number':
              case 'payment_status':
                if (this.filter[key]){
                  string += '&' + key + '=' + this.filter[key]
                }
                break;
              case 'date_create':
                if(this.filter[key][0] !== null && this.filter[key][1]){
                  string += `&${key}=${this.filter[key]}`
                }
                break;

              case 'client_ids':
                if (this.filter[key].length > 0){
                  string += `&${key}=${this.filter[key]}`
                }
                break;
            }
          }
          history.pushState(null, null, this.$route.path + string)
        }
      }
    },
  },
  created () {
    this.check_query()
    this.load_invoices()
  },

  activated () {
    this.check_query()
    this.load_invoices()
  },

  deactivated() {
    this.filter = {
      date: null,
      date_create: [],
      client_ids: [],
      invoice_number: "",
      validation_status: null,
      payment_status: null
    }
  },

  methods: {
    change_invoice_number(){
      if (this.filter.invoice_number) this.filter.date = null
      this.change_input()
    },
    change_input () {
      if (this.timer !== null) {
        clearTimeout(this.timer)
      }
      this.timer = setTimeout(this.load_invoices, 500)
    },
    check_query(){
      if (Object.keys(this.$route.query).length > 0){
        for (let key in this.$route.query){
          switch (key) {
            case 'date':
            case 'validation_status':
            case 'invoice_number':
            case 'payment_status':
              this.filter[key] = this.$route.query[key]
              break;

            case 'date_create':
              this.filter[key] = this.$route.query[key].split(",")
              break;

            case 'client_ids':
              this.filter[key] = this.$route.query[key].split(',').map(item => {
                return Number(item)
              })
              break;

          }
        }
      }
      if (this.filter.invoice_number) this.filter.date = null
    },
    load_invoices(){
      this.$http.v1.getInvoiceList(this.sended_filter, (response) => {
        if (response.data){
          this.invoice_list = response.data.data
          this.summary = response.data.summary
        }else{
          this.global_notify('danger', this.translate('no_data'))
        }
      })
    },
    toggleFiltersState () {
      this.filters_state = !this.filters_state
      this.localStorage.setItem('filters_state', this.filters_state)
    },
  }
}
</script>

<style lang="scss" scoped>

.invoice_list{
  height: 100%;
  padding-top: 30px;
  display: flex;
  flex-direction: column;

  .header{
    display: flex;
    justify-content: space-between;
    & > *{
      margin-right: 10px;
      &:last-child{
        margin-right: 0;
      }
    }
    .filter{
      margin: 0;
    }
    .form{
      display: flex;
      justify-content: space-between;
      align-items: center;
      flex: 2;

      .btn{
        width: 30%;
      }
    }
    .wrap_select{
      width: 100%;
      flex-direction: column;
      .form_select{
        width: 100%;
        margin-bottom: 10px;
        &:last-child{
          margin-bottom: 0;
        }
      }
      .vue-treeselect{
        margin-bottom: 0;
      }
      .form-group{
        margin: 0;
      }
    }
  }

  .invoice{
    cursor: pointer;
    &:hover{
      background-color: #eee;
    }
    td{
      overflow: hidden;
    }
  }
  .response_table{
    th.text-left{
      text-align: left;
    }
    flex: 10;
    padding: 10px 0 0;
    table{
      tbody{
        .online{
          color: #15ab00;
        }
        span{
          font-size: 22px;
        }
      }
      th {
        font-size: 12px;
        &.limit{
          width: 10%;
          min-width: 100px;
        }
        &.device_status{
          width: 120px;
        }
        &.device_tariff{
          width: 120px;
        }
      }
    }
  }
}


@media (max-width: 500px){
  .header{
    .form{
      width: 100%;
      .filter{
        min-width: max-content;
        margin: 0 10px;
      }
    }
    .btn{
      b{
        display: none;
      }
      width: 20%;
      min-width: inherit;
    }
  }

}
</style>
